import { render } from "./BlockType.vue?vue&type=template&id=679d5bbf"
import script from "./BlockType.vue?vue&type=script&lang=js"
export * from "./BlockType.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__